import {listener} from "../../../../modules/vegas/js/util";

listener('submit', 'form[data-form-loader]', (el, e) => {
	let button = el.querySelector('button[type=submit]');

	if (button) {
		button.disabled = true;
		button.innerText = button.dataset.submitText || 'Отправляем...';
	}
});
